module.exports = __webpack_public_path__ + "img/simployal.9cb81d18.svg";